import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { ListHeader, TotalGivenAmountBreakdown, TotalFuturePaymentsBreakdown, ExpectedPrincipalByWeek, CurrentMonthReference, PastPrincipalByMonth, CollectedPaymentsBreakdown, AllPaymentsBreakdown } from 'components';
import { showApiError } from 'utils';
import { getAllFranchises } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var createPage = function createPage(title, Component) {
  var Page = function Page() {
    var _useState = useState([]),
        _useState2 = _slicedToArray(_useState, 2),
        franchises = _useState2[0],
        setFranchises = _useState2[1];

    useEffect(function () {
      getAllFranchises().then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            res = _ref2[0],
            err = _ref2[1];

        if (err) showApiError(err);else setFranchises(res);
      });
    }, []);
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
      title: title
    }), ___EmotionJSX(Component, {
      franchises: franchises
    }));
  };

  Page.displayName = title;
  return Page;
};

export var TotalGivenAmountPage = createPage('Раздадени кредити', TotalGivenAmountBreakdown);
export var TotalFuturePaymentsPage = createPage('Непадежирали главници', TotalFuturePaymentsBreakdown);
export var ExpectedPrincipalPage = createPage('Очаквани средства', ExpectedPrincipalByWeek);
export var CurrentMonthPage = createPage('Средства за месеца', CurrentMonthReference);
export var PastPrincipalPage = createPage('Средства минал период', PastPrincipalByMonth);
export var CollectedPaymentsPage = createPage('Приключили кредити', CollectedPaymentsBreakdown);
export var AllPaymentsPage = createPage('Обща информация кредити', AllPaymentsBreakdown);